
import React, { useEffect, useState } from "react"
import { Modal } from "react-bootstrap"
import btnClose from "../../assets/images/svg/close_modal_icon.svg";
import { LocalizationProvider } from '@mui/x-date-pickers-pro';
import { DateRangePicker, DateRange } from '@mui/x-date-pickers-pro/DateRangePicker';
import AdapterJalali from '@date-io/date-fns-jalali';
import { TextField } from "@material-ui/core";
import moment from 'moment';
import momentFa from 'moment-jalaali'
import { ErrorToast, InfoToast } from "../../shared";
import { GetFinancialPeriods } from "../../api/requestAxios/invoice";
import constants from "../../constants/constants";
import { postInvoice } from "../../api/requestAxios/accounting";


const OutputInvoice = ({
    setOutputInvoice
}) => {

    const [loading, setLoading] = useState(false)
    const [show, setShow] = useState(false)
    const [value, setValue] = useState([null, null]);
    const [financialPeriodIdSelected, setFinancialPeriodIdSelected] = useState('')
    const [isExistFinancialPeriodId, setIsExistFinancialPeriodId] = useState('')
    const [myFinancialPeriodsList, setMyFinancialPeriodsList] = useState()
    const [success, setSuccess] = useState(false)
    const [customerNumber, setCustomerNumber] = useState()

    const [objectModel, setObjectModel] = useState({
        FinancialPeriodId: "",
        FromDate: "",
        ToDate: "",
        OfficialFactorType: "1",
        MaxAccountPartyCodeInSepidarCustomer: ""
    })

    useEffect(() => {
        setShow(true)
        GetFinancialPeriodsFn()
    }, [])


    const GetFinancialPeriodsFn = async () => {

        try {
            const financialPeriodsList = await GetFinancialPeriods()
            setMyFinancialPeriodsList(financialPeriodsList.data)
        }
        catch {
            ErrorToast(constants.ServerErroe)
        }
    }


    const spliteDate = (startValue, endValue) => {
        if (startValue || endValue) {
            let startDate = momentFa(startValue).local('fa').format(' jYYYY-jMM-jDD HH:MM')
            let startYear = startDate.split('/')[0]

            let endDate = momentFa(endValue).local('fa').format(' jYYYY-jMM-jDD HH:MM')
            let endYear = endDate.split('/')[0]

            if (endYear || startYear) {
                return endYear
            }
            else {
                return false
            }
        }
        else {
            return false
        }

    }

    const findFinantialYear = (start, end) => {
        let result = spliteDate(start, end)
        let newYear = ''
        if (result) {
            // myFinancialPeriodsList.forEach((item, index) => {
            //     if (item.Year.trim() === result.trim()) {
            //         newYear = item.FinancialPeriodId
            //     }
            // })
            let yearSelected = result.split('-')[0]
            if (parseInt(yearSelected.trim()) >= 1399 && parseInt(yearSelected.trim()) <= 1408) {
                newYear = myFinancialPeriodsList[0]?.FinancialPeriodId
            }
        }
        return newYear
    }

    useEffect(() => {
        let start = moment(value[0], 'YYYY-jMM-jDD').isValid()
        let end = moment(value[1], 'YYYY-jMM-jDD').isValid()

        let temp = { ...objectModel }
        temp.FromDate = moment(new Date(value[0])).local('en').format(' YYYY-MM-DD')
        temp.ToDate = moment(new Date(value[1])).local('en').format(' YYYY-MM-DD')
        setObjectModel(temp)

        if (start && end && value[0] !== value[1]) {
            let year = findFinantialYear(value[0], value[1])
            if (year) {
                setFinancialPeriodIdSelected(year)
                setIsExistFinancialPeriodId(true)
            }
            else {
                setIsExistFinancialPeriodId(false)
                ErrorToast('سال مالی انتخاب شده وجود ندارد')
            }
        }
    }, [value])



    useEffect(() => {
        if (success) {
            InfoToast('لیست سرویس‌ها در حال دانلود می‌باشد')
        }

    }, [success])


    const handleClose = () => {
        setShow(false)
        setOutputInvoice(false)
    }

    const getMaxDate = (date) => {
        if (!date) {
            return date
        }
        const startTime = new Date(date).getTime()
        const month = date.getMonth();
        const year = date.getFullYear();
        let daysInMonth = new Date(year, month, 0).getDate();
        daysInMonth = daysInMonth + 3
        return new Date(startTime + daysInMonth * 24 * 60 * 60 * 1000)
    }

    const maxDate = React.useMemo(() => getMaxDate(value[0]), [value])


    const getInvoiceSepidar = async () => {
        let failed = false
        try {
            setLoading(true)
            let temp = { ...objectModel }
            temp.FinancialPeriodId = financialPeriodIdSelected
            const services = await postInvoice(temp)
            if (services?.data?.Success !== undefined && !services?.data?.Success) {
                failed = true
                ErrorToast(services?.data?.Message)

            }
            else if (services.data) {
                var mediaType = "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,";
                var a = document.createElement('a');
                a.href = mediaType + services.data;
                a.download = `${Date.now()}.xlsx`;
                a.textContent = 'Download file!';
                document.body.appendChild(a);
                a.click()
                document.body.removeChild(a);
                setOutputInvoice(false)
            }
            setLoading(false)
            // const url = window.URL.createObjectURL(new Blob([services.data]));
            // const link = document.createElement('a');
            // link.href = url;
            // link.setAttribute('download', `${Date.now()}.xlsx`);
            // document.body.appendChild(link);
            // link.click();
            // failed = false
            // setOutputInvoice(false)
        }
        catch {

            failed = true
            setLoading(false)
            ErrorToast('عملیات با مشکل سیستمی مواجه شد')
            setOutputInvoice(false)
        }
        setSuccess(!failed)
    }

    const onChaneCusomer = (e) => {
        let temp = { ...objectModel }
        temp.MaxAccountPartyCodeInSepidarCustomer = e.target.value
        setObjectModel(temp)

    }
    return (
        <Modal show={show} animation={true} dir="rtl" className="accounting-modal" >
            <Modal.Header>
                <Modal.Title className="d-flex justify-content-between w-100" style={{ fontSize: '16px' }}>
                    تعیین بازه‌ی زمانی
                    <img
                        alt=""
                        onClick={handleClose}
                        src={btnClose}
                        className="btn-close-modal"
                    />
                </Modal.Title>
            </Modal.Header>
            <Modal.Body >
                <div className="d-flex flex-row justify-content-start date-range-invoice-holder">
                    <LocalizationProvider
                        dateAdapter={AdapterJalali}
                        localeText={{ start: 'خروجی تا', end: 'خروجی از' }}
                    >
                        <DateRangePicker
                            startText="از تاریخ"
                            endText="تا تاریخ"
                            maxDate={maxDate}
                            value={value}
                            onChange={(newValue) => {
                                setValue(newValue);
                            }}
                            renderInput={(startProps, endProps) => (
                                <React.Fragment>
                                    <span>خروجی از </span>
                                    <TextField {...startProps} />
                                    <br />
                                    <span>خروجی تا </span>
                                    <TextField {...endProps} />
                                </React.Fragment>
                            )}
                        />
                    </LocalizationProvider>

                </div>
                <div className="customer-wrapper">
                    <label className="d-flex flex-row justify-content-start">شماره مشتری</label>
                    <input
                        className="d-flex flex-row justify-content-start costumer-input"
                        required
                        onChange={onChaneCusomer}
                        value={objectModel?.MaxAccountPartyCodeInSepidarCustomer}

                    />
                </div>
            </Modal.Body>
            {
                <Modal.Footer className="d-flex flex-row justify-content-center accounting-modal-footer-view accounting-list">
                    <button className="btn btn-primary btn-custom" onClick={getInvoiceSepidar} disabled={!isExistFinancialPeriodId}>
                        {loading ? <div className="spinner-border" role="status" aria-hidden="true"></div> : 'دریافت فاکتورها'}

                    </button>
                </Modal.Footer>
            }

        </Modal >
    )
}
export default OutputInvoice